import { render, staticRenderFns } from "./applyDecord.vue?vue&type=template&id=5f51b138&scoped=true&"
import script from "./applyDecord.vue?vue&type=script&lang=js&"
export * from "./applyDecord.vue?vue&type=script&lang=js&"
import style0 from "./applyDecord.vue?vue&type=style&index=0&id=5f51b138&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f51b138",
  null
  
)

export default component.exports